import React, { createContext, FC, ReactNode, useContext } from 'react'

import { ClientConfig, getClientConfig, setClientConfig } from '@Globals/Config'

const ClientConfigContext = createContext<ClientConfig | undefined>(undefined)

interface ConfigProviderProps {
  children: ReactNode
  value: ClientConfig
}

/**
 * Makes the browser-safe config available to React (useClientConfig) and to non-React code
 * (getClientConfig). Render it once, as the outermost provider.
 */
export const ConfigProvider: FC<ConfigProviderProps> = ({ children, value }) => {
  // Also fills the non-React slot, so modules such as Apollo and Algolia can read the same value.
  setClientConfig(value)

  return (
    <ClientConfigContext.Provider value={value}>
      {children}
    </ClientConfigContext.Provider>
  )
}

export const useClientConfig = (): ClientConfig => useContext(ClientConfigContext) ?? getClientConfig()
